import * as React from 'react';

import {BackButton} from 'shells/button/back-button/back-button';
import {Button} from 'shells/button/button';
import {IconButton} from 'shells/button/icon-button/icon-button';
import {colors} from 'shells/colors/colors';
import {BookIcon} from 'shells/icon/svg/book-icon';
import {Stack} from 'shells/layout/stack/stack';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import {NewBroadcastModal} from '../../email-marketing/broadcasts/new-broadcast-modal';

import {AiFeatureGateModal} from '../ai-feature-gate-modal/ai-feature-gate-modal';
import {getSelectedUsageTab} from '../helpers';

import {handleTryItFeature, isTryItFeature} from './helpers';
import type {AiFeature} from './types';

interface Props {
    feature: AiFeature;
    requiresUpgrade?: boolean;
}

export function FeaturePageNavHeader(props: Props) {
    const canTryIt = React.useMemo(() => isTryItFeature(props.feature.type), [props.feature.type]);
    const [showEmailCampaignBuilder, setShowEmailCampaignBuilder] = React.useState<boolean>(false);
    const [showFeatureGateModal, setShowFeatureGateModal] = React.useState<boolean>(false);

    const handleTryIt = () => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_AI_HOMEPAGE_FEATURED_TRIED, {
            feature: props.feature.type,
        });
        // @ts-expect-error
        handleTryItFeature(props.feature.type as TryItFeature, setShowEmailCampaignBuilder);
    };

    return (
        <div className='flex full-width py-16'>
            <Stack
                spacing={16}
                isFullWidth={true}
                isHorizontal={true}
                justifyContent='space-between'
            >
                <BackButton
                    backText='Back'
                    as='button'
                    // @ts-expect-error
                    onClick={() => {
                        const currentPeriod = getSelectedUsageTab(window.location.search);

                        appHistory.replace(`/ai/home?period=${currentPeriod.toLowerCase()}`);
                    }}
                />
                <Stack isHorizontal={true} spacing={8}>
                    {props.feature.learnMoreLink && (
                        <IconButton
                            icon={BookIcon}
                            size={16}
                            text='Learn more'
                            variant='ai'
                            color={colors.aiPurplePrimary}
                            noHoverBackground={true}
                            onClick={() => window.open(props.feature.learnMoreLink, '_blank')}
                        />
                    )}
                    {props.requiresUpgrade ? (
                        <Button
                            variant='ai-purple-dark'
                            size='big'
                            onClick={() => setShowFeatureGateModal(true)}
                        >
                            Upgrade to unlock
                        </Button>
                    ) : (
                        canTryIt && (
                            <Button variant='ai-purple-dark' size='big' onClick={handleTryIt}>
                                Try it now
                            </Button>
                        )
                    )}
                </Stack>
            </Stack>
            <NewBroadcastModal
                isOpen={showEmailCampaignBuilder}
                onClose={() => setShowEmailCampaignBuilder(false)}
                initialSelectedCategoryOrTemplateApiId='ai-email-template'
            />
            <AiFeatureGateModal
                isOpen={showFeatureGateModal}
                onClose={() => setShowFeatureGateModal(false)}
                reason='notInPlan'
                featureName={props.feature.name}
                aiFeatureType={props.feature.type}
            />
        </div>
    );
}
